import styled from 'styled-components'

export const ProductWizardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 186px);
  grid-gap: 17px;
  grid-template-rows: 96px 96px 96px;
  height: 333px;
  overflow-y: auto;
  justify-content: center;
  margin-bottom: 26px;

  ${props => props.theme.media.mobile`
    grid-template-columns: repeat(2, 124px);
    grid-gap: 8px;
    height: 208px;
    overflow-y: auto;
  `}
`

export const ProductWizardCardItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  width: 186px;
  height: 104px;
  border-radius: 12px;
  background-color: ${props => props.theme.color.primary25};
  white-space: normal;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
  word-break: break-word;

  &:hover {
    background-color: ${props => props.theme.color.primary100};
  }

  ${props => props.theme.media.mobile`
    width: 124px;
    height: 80px;
  `}
`

export const SpinnerWrap = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StepFormWrapper = styled.div`
  overflow-y: hidden;

  ${props => props.theme.media.mobile`
  overflow-x: hidden;
  width: 300px;
`}
`

export const StepYieldAndPounds = styled.div`
  height: 280px;
  display: flex;
  justify-content: center;
  overflow-y: auto;
`

export const ProcoteProductContainer = styled.div`
  height: 325px;
  display: flex;
  justify-content: center;
  overflow-y: auto;

  ${props => props.theme.media.mobile`
    max-width: none;
  `}
`
